<template>
  <form-block
    :title="tr('URL parameters')"
    :description="tr('A query string that follows the main URL in a web address. This parameter helps in analyzing and tracking advertisements as it allows us to determine exactly which ad has brought the visitor to the website. You can easily set this parameter with the help of the macros.')"
  >
    <templateable-input
      v-model="entity.settings.url_params"
      :template-parts="urlTemplateableParts"
      :disabled="disabled"
    />

    <template v-if="entity.settings.url_params">
      <p class="m-0 text-sm text-muted-foreground [overflow-wrap:anywhere]">
        {{ tr('Preview') }}: <span class="text-foreground">{{ urlParamsPreview }}</span>
        <loader-circle-icon v-if="urlParamsIsLoading" class="ml-1 inline size-4 animate-spin align-[-0.2em]" />
      </p>
    </template>
  </form-block>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import ToolService from '@/services/Tool.js';
import TemplateableInput from '@/ui/components/TemplateableInput.vue';
import debounce from '@/utils/debounce.js';

export default {
  name: 'UrlParamsBlock',
  components: {
    LoaderCircleIcon: LoaderCircle,
    TemplateableInput,
  },
  mixins: [ RuleFormBlockMixin ],
  data() {
    return {
      isMounted: false,
      urlParamsPreviewGenerator: debounce(() => this.generateUrlParamsPreview(), 500),
      urlParamsPreview: '–',
      urlParamsIsLoading: false,
    };
  },
  computed: {
    urlTemplateableParts() {
      const parts = [];
      let previousGroup = '';
      for (const item of this.$store.getters['app/urlParamMacros']) {
        if (item.group !== previousGroup) {
          parts.push({ title: item.group });
          previousGroup = item.group;
        }
        parts.push({ label: item.label, value: item.machine_name });
      }
      return parts;
    },
  },
  watch: {
    'entity.settings.url_params'() {
      this.urlParamsPreviewGenerator();
    },
  },
  mounted() {
    this.isMounted = true;
  },
  beforeUnmount() {
    this.isMounted = false;
  },
  created() {
    this.generateUrlParamsPreview();
  },
  methods: {
    validate() {
      // TODO: url query parameter validation.

      return true;
    },
    generateUrlParamsPreview() {
      if (this.urlParamsIsLoading) {
        return;
      }

      this.urlParamsIsLoading = true;

      const campaign = this.entity.output_campaign.toObject();
      campaign.ad_account = this.entity.ad_account.toObject();
      campaign.name = this.entity.campaignName;

      let sourceProfileId = null;
      if (
        Array.isArray(this.entity.source_profiles)
        && this.entity.source_profiles.length > 0
      ) {
        sourceProfileId = this.entity.source_profiles[0].id;
      }

      ToolService.getExampleUrlParams({
        template: this.entity.settings.url_params,
        sourceProfileId,
        campaign,
      })
        .then(resp => {
          if (!this.isMounted) {
            return resp;
          }

          if (resp) {
            this.urlParamsPreview = resp;
          }
          else {
            this.urlParamsPreview = '–';
          }

          return resp;
        })
        .catch(() => this.urlParamsPreview = '–')
        .finally(() => this.urlParamsIsLoading = false);
    },
  },
};
</script>
